import React from 'react'

function FeatureSteps({ content }) {
  return (
    <section id={'FeatureSteps'} className="FeatureSteps">
      <hr />
      <h1>{content.h}</h1>
      <p>{content.p}</p>
      {content.main.map((content, _idx) => (
        <FeatureStepsItem key={`FeatureStepsItem-${_idx}`} content={content} />
      ))}
    </section>
  )
}

function FeatureStepsItem({ content }) {
  return (
    <div
      className={'FeatureSteps-item'}
      style={{ backgroundColor: content.color }}
    >
      <p>{content.hSub}</p>
      <h1>{content.h}</h1>
      <div className={'FeatureSteps-itemContent'}>
        <p>{content.p}</p>
        {content.items && (
          <div className={'FeatureSteps-itemContentItems'}>
            {content.items.map(({ href, name, img }, _idx) => (
              <a
                href={href}
                key={`FeatureSteps-itemContentItem-${_idx}`}
                target="_blank"
                className={'FeatureSteps-itemContentItem'}
              >
                <div
                  className={'FeatureSteps-itemContentItemImg'}
                  style={{ backgroundColor: content.itemColor }}
                >
                  <img src={img} alt={name} />
                </div>
                <p>{name}</p>
              </a>
            ))}
          </div>
        )}
      </div>
      {content.splash && (
        <div className={'FeatureSteps-splash'}>{content.splash}</div>
      )}
    </div>
  )
}

export default FeatureSteps



// WEBPACK FOOTER //
// ./src/Views/Home/FeatureSteps.js